import { render, staticRenderFns } from "./ManageList.vue?vue&type=template&id=b15504fa&"
import script from "./ManageList.vue?vue&type=script&lang=js&"
export * from "./ManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports